import { render, staticRenderFns } from "./vales.vue?vue&type=template&id=0bad138e&scoped=true"
import script from "./vales.vue?vue&type=script&lang=js"
export * from "./vales.vue?vue&type=script&lang=js"
import style0 from "./vales.vue?vue&type=style&index=0&id=0bad138e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad138e",
  null
  
)

export default component.exports